// ARCHX AI — Admin allow-list
// Only these accounts can see the Engine Monitor (the live ops view).
// Add/remove emails here. Matching is case-insensitive.
export const ADMIN_EMAILS = [
  'dereck.fandel@archxai.io',
];

export function isAdmin(user) {
  if (!user || !user.email) return false;
  return ADMIN_EMAILS.map(e => e.toLowerCase()).includes(user.email.toLowerCase());
}
